import {
    VIEW_VENDORLIST_REQUEST,
    VIEW_VENDORLIST_SUCCESS,
    VIEW_VENDORLIST_FAIL
  } from "../constants/AuthConstant";

import axios from "axios";
import { toast } from "react-toastify";

const baseUrl = process.env.REACT_APP_API_PATH

export const VendorDashboardAction = ({ pageNumber, size, search, activeTab, filterActive }) => {
    return function (dispatch) {
      
      dispatch({
        type: VIEW_VENDORLIST_REQUEST,
        payload: true,
      });
  
      // let OPTION = {
      //   // http://ebench-env.eba-tckyjspw.ap-south-1.elasticbeanstalk.com/ebench
      //   url: `${baseUrl}/ebench/get_all_vendor?pageNumber=0&pageSize=10&search=`,
      //   method: "GET",
        
      //   headers: {
      //     "content-type": "application/json",
      //   },
      // };
      axios.get(`${baseUrl}/ebench/get_all_vendor?pageNumber=${pageNumber}&pageSize=${size}&search=${search}&isAccountVerified=${activeTab}&status=${filterActive}`)
        .then((res) => {
          dispatch(GetVendorData(res.data));
          //  localStorage.setItem("userInfo", JSON.stringify(res.data));
          //   window.location.href = "/";
        })
        .catch((error) => {
          dispatch({
            type: VIEW_VENDORLIST_FAIL,
            payload: false,
            error: error,
            createJob: error.success,
            msg: "Failed to create user registration",
          });
          toast.error(error.msg);
        });
    };
  };


export const ViewVendorDashboardAction = ({ vendorId }) => {
  return async function (dispatch) {
    try {
      // Dispatch request start
      await dispatch({
        type: VIEW_VENDORLIST_REQUEST,
        payload: true,
      });

      // Make the API call
      const res = await axios.get(`${baseUrl}/ebench/get_vendor_by_vendorId?vendorId=${vendorId}`);

      // Dispatch successful response
      dispatch(GetVendorData(res.data));

      // ✅ Return the data so the caller can use `.then()`
      return res.data;

    } catch (error) {
      // Dispatch failure
      dispatch({
        type: VIEW_VENDORLIST_FAIL,
        payload: false,
        error: error,
        createJob: error.success,
        msg: "Failed to create user registration",
      });

      toast.error(error.msg);

      // ❗ Rethrow so caller can .catch() the error
      throw error;
    }
  };
};

  

  export const ViewSelectedCandidateList = ({pageNumber,size,search}) => {
    return function(dispatch) {
      dispatch({
        type: VIEW_VENDORLIST_REQUEST,
        payload: true,
      });

      axios.get(`${baseUrl}/ebench/interview/get_selected_candidate_list?search=${search}&pageNumber=${pageNumber}&pageSize=${size}`)
      .then((res) => {
        dispatch(GetVendorData(res?.data));
        //  localStorage.setItem("userInfo", JSON.stringify(res.data));
        //   window.location.href = "/";
      })
      .catch((error) => {
        dispatch({
          type: VIEW_VENDORLIST_FAIL,
          payload: false,
          error: error,
          createJob: error.success,
          msg: "Failed to create user registration",
        });
        toast.error(error.msg);
      });
    }
  }


  export const GetVendorData = (data) => {
    // toast.success("Added Successfully.");
    // setTimeout(()=>{
    //     window.location.href = "/candidate_dashboard";
    //  },2000)
    return {
      type: VIEW_VENDORLIST_SUCCESS,
      createJob: data.status.message,
      result: data,
      payload: false,
      loading: false,
      msg: data.status.message,
    };
  };

  // change Acceptance Status in vendor side management.
  
  export const Change_Acceptance_Status = (orderId,AcceptanceStatus,remark) => {
    return function (dispatch) {
      return new Promise((resolve, reject) => {
        dispatch({
          type: VIEW_VENDORLIST_REQUEST,
          payload: true,
        });
  
        let OPTION = {
          url: `${process.env.REACT_APP_API_PATH}/ebench/change_acceptance_status_of_purchase_order?purchaseOrderId=${orderId}&purchaseOrderAcceptanceStatus=${AcceptanceStatus}&remark=${remark}`,
          method: "PATCH",
        };
  
        axios(OPTION)
          .then((res) => {
            dispatch(getUpdatedDetails(res.data));
            resolve(res.data); // Resolving the promise with the response data
          })
          .catch((error) => {
            toast.error(error?.response?.data?.status?.message || "Failed to create purchase order");
            dispatch({
              type: VIEW_VENDORLIST_FAIL,
              payload: false,
              error: error,
              msg: "Failed to load the information",
            });
            reject(error); // Rejecting the promise with the error
          });
      });
    };
  }

  export const getUpdatedDetails = (data) => {
    // toast.success("Order Created Successfully!");
    return {
      type: VIEW_VENDORLIST_SUCCESS,
      result: data,
      payload: false,
      loading: false,
      msg: "SUCCESS",
    };
  };